// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card_StePb{width:100%;border-radius:8px;background:#232f3f;overflow:hidden}.top_T8RbK{display:grid;grid-template-columns:48px 1fr;grid-gap:8px;align-items:center;padding:12px;background:#2b3848}.bottom_p8Hbh{padding:12px}.avatar_XjIPD{width:48px;height:48px;border-radius:50%}.header_12QWZ{display:grid;grid-template-columns:1fr;grid-gap:4px}.headerRow_ucmPL{display:flex;align-items:center;justify-content:space-between}.name_up-L0{color:#fff;font-size:14px;font-weight:500;line-height:20px}.date_NAUj8{color:#fff;font-size:12px;font-weight:400;line-height:20px}.total_y7XU7{color:#fff;font-size:14px;font-weight:500;line-height:20px}.stars_aT6he{display:flex;align-items:center;justify-content:flex-start}.star_ubET2{width:16px;height:16px}.title_X7f\\+B{margin:0 0 8px;color:#fff;font-size:16px;font-weight:700;line-height:22px}.description_v7Tpc{margin:0;color:#cfd8dc;font-size:14px;font-weight:400;line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": "card_StePb",
	"top": "top_T8RbK",
	"bottom": "bottom_p8Hbh",
	"avatar": "avatar_XjIPD",
	"header": "header_12QWZ",
	"headerRow": "headerRow_ucmPL",
	"name": "name_up-L0",
	"date": "date_NAUj8",
	"total": "total_y7XU7",
	"stars": "stars_aT6he",
	"star": "star_ubET2",
	"title": "title_X7f+B",
	"description": "description_v7Tpc"
};
module.exports = ___CSS_LOADER_EXPORT___;
